import {AbstractAPIPlatformProvider} from './abstract';
import {Currency as CurrencyModel} from '../model';
import {PROVIDER} from '../../../resources/bcmApi';

export class Currency extends AbstractAPIPlatformProvider {
  name = PROVIDER.CURRENCIES;
  model = new CurrencyModel();
}
